import ModalWindowGroup from "./ModalWindowGroup";

const ModalWindowGroupStore = {
	defaultGroup: new ModalWindowGroup()
};
export default ModalWindowGroupStore;
